// extracted by mini-css-extract-plugin
export default {"game__container":"rI3f0"};